export type Order = 'desc' | 'asc';

export type Sort = Partial<Record<string, Order>>;

export interface PaginationInfo {
	total: number;
	previous: number;
	next: number;
	current: number;
	pages: number;
}

export interface SearchProps {
	limit?: number;
	offset?: number;
	searchQuery?: string;
	sort?: Sort;
}

export const ROWS_PER_PAGE = [5, 10, 15, 25, 50, 100];
